import { createContext, useContext } from 'react'

import type { ModalProps } from './modal'

export enum ConfirmResult {
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
  DISMISSED = 'dismissed',
}

export type ConfirmModalOptions = Pick<
  ModalProps,
  | 'title'
  | 'subtitle'
  | 'variant'
  | 'primaryButtonText'
  | 'cancelButtonText'
  | 'showCancelButton'
  | 'closable'
  | 'size'
> & {
  content?: React.ReactNode
}

export type ConfirmModalContextValue = {
  confirm: (options: ConfirmModalOptions) => Promise<ConfirmResult>
}

export const ConfirmModalContext = createContext<ConfirmModalContextValue | null>(null)

export const useConfirmModal = () => {
  const context = useContext(ConfirmModalContext)
  if (!context) {
    throw new Error('useConfirmModal must be used within a ConfirmModalProvider')
  }
  return context
}
